import React from "react";
import { ViewMoreIcon } from "../assets/icons";
import useDeleteData from "../hooks/useDeleteData";
import useDeleteMaster from "../hooks/useDeleteMaster";

function CommonViewMore({ data={}, fetcher=()=>{},link="", alter_method=false}) {
  const { handleDelete } = useDeleteData();
  const { deleteMaster } = useDeleteMaster();

  const deleteAction = () => {
    if (!alter_method) {
      handleDelete({
        url: `/${link}/${data?.id}/`,
        id: data?.id,
        value: data?.image_name,
        fetcher: fetcher,
      })
    }else{
      deleteMaster({
        url: `/${link}`,
        name: data?.image_name,
        value : { standard_id: data?.standard_id, doc_path:data?.actual_path},
        getData: fetcher
      })
    };
  };

  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[7px] rounded-3xl h-8 bg-white dropdown cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white rounded-xl w-16 absolute -left-16 -top-1">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer text-sm"
                onClick={() => deleteAction() }
              >
                Delete
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommonViewMore;
